import styled, { css } from "styled-components"
import { dark } from "styles/theme"
import { Link } from "styles/GlobalStyle"
import { Center } from "styles/GlobalCss"
import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";
import { borderRadius, fontSize, height, minHeight } from "@mui/system";
import { thirdly2 } from "styles/theme";

export const LoginStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    color: dark,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
     '.footer-message': {
        fontSize: 15,
        position: "absolute",
        bottom: 10
    },
    '.login-option-btn': {

    },
    '.submit-btn': {
        width: 100
    },
    '.login-option-icon': {
        position: "absolute",
        left: 6,
        width: 28,
        height: 28,
        display: "flex",
        alignItems: "center",
        '.MuiSvgIcon-root': {
            height: 29,
            width: 28,
        }
    },
    '.login-option-label': {
        flexGrow: 1
    },
    '.login-options': {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        rowGap: 8,
        'a': {
            textDecoration: "auto",
            width: "100%",
            display: "block",
            color: dark
        },
        '.MuiBox-root': {
            width: "100%",
        },
        '.MuiButtonBase-root.MuiButton-root.MuiLoadingButton-root': {
            width: "100%",
            background: "transparent",
            border: `2px solid ${thirdly2}`,
            color: dark
        }
    },
    '.forgot-username-or-password': {
        display: "flex",
        justifyContent: "flex-start",
        padding: "0px 0px 15px 0px"
    },
    '.register-btn': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    '.new-user': {
        width: 370,
        fontSize: 18,
        fontWeight: 700
    }
}));

export const UnregisterUserStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    color: dark,
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    fontSize: 25,
    '.logout-btn': {
        position: "absolute",
        top: 20,
        right: 20,
        zIndex: 12
    },
    '.message': {
        height: "100%"
    },
    '.form-content': {
        height: "100%",
        marginTop: 100
    },
}));

export const InstallButtonStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    columnGap: 20
}));

export const FormFieldStyles = muiStyled(Box)(({ hideAuthTab, theme, $systemUI }) => ({
    width: 430,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "20px 0px",
    boxSizing: "border-box",
    justifyContent: "center",
    [theme.breakpoints.down('lg')]: {
        justifyContent: "start",
    },
    '.header': {
        height: "25%",
        minHeight: 120,
        display: "flex",
        alignItems: "end"
    },
    '.form-content': {
        width: "100%",
    },
    '.content': {
        width: "100%",
        justifyContent: "center",
        height: 530,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        bottom: "30px"
    },
    'form': {
        height: "auto !important"
    },
    '.login-or-registration': {
        width: "100%",
        boxSizing: "border-box",
        marginBottom: 20,
        background: "white",
        borderRadius: 35,
        height: 50,
        display: "flex",
        columnGap: 20,
        justifyContent: "space-around",
        alignItems: "center",
        padding: "0px 10px",
        marginBottom: 50
    }
}));

export const WrapAuth = styled.div`
display: flex;
height: 100%;
`

export const Logo = styled.div`
position: absolute;
top: 10px;
left: 25px;
right: 25px;
display: flex;
justify-content: space-between;
align-items: center;
flex-grow: 1;

.MuiSvgIcon-root{
width:150px;
height:70px;
}

.install-button{
width:300px;
z-index:1;
}
`

export const InstructionItem = styled.li`
color: rgba(0, 0, 0, 0.50);
font-size: 17px;
`

export const Instructions = styled.ul`
margin-block-start: inherit;
display: flex;
flex-direction: column;
row-gap: 6px;
`

export const FormContent = styled.div`
width:400px;

`

export const ForgotUserNameOrPassword = styled.div`
flex-grow:1;
display:flex;
align-items: start;
column-gap:5px;
`

export const RegisterLink = styled(Link)`
    position: relative;
    top: 10px;
`

export const WrapLogo = styled.div`
width: 208.77px;
height: 156.28px;
`

export const Left = styled.div`
background:${dark};
width:40%;
display: flex;
align-items: center;
justify-content: center;
`

export const Right = styled.div`
width:60%;
display: flex;
align-items: center;
justify-content: center;
`

export const WrapForm = styled.div`
display:flex;
overflow-y:auto;
align-items:center;
justify-content:center;
height:100%;
position: relative;
min-width:800px;
width:100%;
column-gap:100px;


@media only screen and (min-width: 1700px) {
column-gap:130px;
}

    `

export const WrapCartoon = styled.div`
display:flex;
justify-content:start;
`

export const CartoonItem = styled.div`
width: ${props => props.width || "500"}px;
height: ${props => props.height || "400"}px;
`
